import React from 'react';
interface GlassCardProps {
  children: ReactNode;
  className?: string;
}
const GlassCard: React.FC<GlassCardProps> = ({
  children,
  className = ''
}) => {
  return <div className={`relative backdrop-blur-lg bg-[#FAFAFA]/5 rounded-2xl shadow-lg border border-[#FAFAFA]/10 p-4 overflow-hidden ${className}`} data-id="element-1511">
      <div className="relative z-10" data-id="element-1512">{children}</div>
      <div className="absolute top-0 left-0 right-0 h-1/2 bg-gradient-to-b from-[#FAFAFA]/10 to-transparent pointer-events-none" data-id="element-1513"></div>
    </div>;
};
export default GlassCard;